import { useEffect, useState } from 'react'
import isAfter from 'date-fns/isAfter'
import axios, { AxiosError } from 'axios'
import { auth } from 'firebase/index'
import { FETCH_CANCEL_DEADLINE_ENDPOINT } from 'constants/urls'

const useCancelDeadline = (checkout_at: Date, lastPickupTime: Date, payment_method: string, uid: string): Date => {
  const [deadline, setDeadline] = useState<string>('')
  useEffect(() => {
    ;(async () => {
      if (!checkout_at || !payment_method || !uid || payment_method === '' || uid === '') return
      // トークンを再取得する
      const token = await auth.currentUser?.getIdToken()
      if (typeof !token === 'undefined') {
        console.error('認証トークンの取得に失敗しました。')
        return
      }
      try {
        const res = await axios.post(
          FETCH_CANCEL_DEADLINE_ENDPOINT,
          { checkout_at, payment_method, uid },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        setDeadline(res.data.deadline)
      } catch (e) {
        if (axios.isAxiosError(e)) {
          console.error(e.response)
        } else {
          console.error(e)
        }
      }
    })()
  }, [checkout_at, payment_method, uid])
  const deadlineDate = deadline !== '' ? new Date(deadline) : new Date()
  return isAfter(deadlineDate, lastPickupTime) ? lastPickupTime : deadlineDate
}

export default useCancelDeadline
